import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2rem;
  border: 2px solid white;
`;
